import { combineReducers } from "redux";

import { alert } from "../components/Alert/reducers/alert.reducer";

import { cardSchemes } from "../components/CardSchemes/reducers/cardscheme.reducers";
import { addCardScheme } from "../components/CardSchemes/reducers/add.cardscheme.reducers";
import { viewCardScheme } from "../components/CardSchemes/reducers/view.cardscheme.reducers";

import { cardTypes } from "../components/CardTypes/reducers/cardtype.reducers";
import { addCardType } from "../components/CardTypes/reducers/add.cardtype.reducers";
import { viewCardType } from "../components/CardTypes/reducers/view.cardtype.reducers";

import { idTypes } from "../components/IdTypes/reducers/idtype.reducers";
import { addIdType } from "../components/IdTypes/reducers/add.idtype.reducers";
import { viewIdType } from "../components/IdTypes/reducers/view.idtype.reducers";

import { cardIssuers } from "../components/CardIssuers/reducers/cardissuer.reducers";
import { addCardIssuer } from "../components/CardIssuers/reducers/add.cardissuer.reducers";
import { viewCardIssuer } from "../components/CardIssuers/reducers/view.cardissuer.reducers";

import { domains } from "../components/Domains/reducers/domain.reducers";
import { addDomain } from "../components/Domains/reducers/add.domain.reducers";
import { viewDomain } from "../components/Domains/reducers/view.domain.reducers";

import { institutions } from "../components/Institutions/reducers/institution.reducers";
import { addInstitution } from "../components/Institutions/reducers/add.institution.reducers";
import { viewInstitution } from "../components/Institutions/reducers/view.institution.reducers";

import { clients } from "../components/Clients/reducers/client.reducers";
import { addClient } from "../components/Clients/reducers/add.client.reducers";
import { viewClient } from "../components/Clients/reducers/view.client.reducers";

import { currencies } from "../components/Currencies/reducers/currency.reducers";
import { addCurrency } from "../components/Currencies/reducers/add.currency.reducers";
import { viewCurrency } from "../components/Currencies/reducers/view.currency.reducers";

import { coreCurrencies } from "../components/ISW-Core/reducers/core.currencies.reducer";
import { coreDomains } from "../components/ISW-Core/reducers/core.domains.reducer";
import { coreIssuers } from "../components/ISW-Core/reducers/core.issuers.reducer";

import { addConfig } from "../components/Configs/reducers/add.configs.reducers";
import { configs } from "../components/Configs/reducers/configs.reducers";
import { viewConfig } from "../components/Configs/reducers/view.configs.reducers";

import { cardStatus } from "../components/StatusViews/CardStatus/reducers/cardStatus.reducers";
import { walletStatus } from "../components/StatusViews/WalletStatus/reducers/walletStatus.reducers";

export default combineReducers({
  alert,
  cardSchemes,
  addCardScheme,
  viewCardScheme,
  cardTypes,
  addCardType,
  viewCardType,
  idTypes,
  addIdType,
  viewIdType,
  cardIssuers,
  addCardIssuer,
  viewCardIssuer,
  domains,
  addDomain,
  viewDomain,
  institutions,
  addInstitution,
  viewInstitution,
  clients,
  addClient,
  viewClient,
  currencies,
  addCurrency,
  viewCurrency,
  coreCurrencies,
  coreDomains,
  coreIssuers,
  addConfig,
  configs,
  viewConfig,
  cardStatus,
  walletStatus
});
